<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <!--<v-card class="pa-2 card-r mb-2">-->
      <!--<v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">-->
        <!--<div class="text-xs-left f-20">My Profile</div>-->
      <!--</v-toolbar>-->
    <!--</v-card>-->

      <!--<v-layout row class="pb-2 px-0 ">-->
        <!--<v-flex class="text-xs-right">-->
          <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">edit</v-icon></v-btn>-->
          <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">delete</v-icon></v-btn>-->
          <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">block</v-icon></v-btn>-->
        <!--</v-flex>-->
      <!--</v-layout>-->
    <v-card class="pa-2 mb-2 card-r">

    <v-layout row class="px-0">

        <v-flex>
          <v-tabs
            hide-slider
            class="top-tab w-100"
            slot="extension"
            v-model="profileTabs"
            centered
            fixed-tabs
            color="transparent"
          >
            <v-tabs-slider color="blue"></v-tabs-slider>
            <v-tab to="#AdminPersonal" class="primary--text f-12 w-20 text-capitalize">Personal</v-tab>
            <v-tab to="#Media" class="primary--text f-12 w-20 text-capitalize">gallery</v-tab>
            <v-tab to="#PurchasedPackage" class="primary--text f-12 w-20 text-capitalize">Heyway Products</v-tab>
            <v-tab to="#Payment" class="primary--text f-12 w-20 text-capitalize">Payment Info</v-tab>
            <v-tab to="#subscription" class="primary--text f-12 w-20 text-capitalize">Subscription</v-tab>


          </v-tabs>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card class="pa-2 card-r grey lighten-4">
    <v-layout>
        <v-flex>
          <v-tabs-items v-model="profileTabs">
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="AdminPersonal" >
              <admin-personal/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="Media">
              <media/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="PurchasedPackage">
              <purchased-package/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="Payment">
              <payment-methord/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="subscription">
              <subscription/>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-card>
    </v-container>
</template>
<script>
/* eslint-disable */
import AdminPersonal from "./AdminPersonal";
import PaymentMethord from "./PaymentMethord";
import PurchasedPackage from "./PurchasedPackage";
import Subscription from "./Subscription";
import Media from "./Media";
import { dispatch } from "vuex";

export default {
  name: "AdminProfile",
  data: () => ({
    profileTabs: null
  }),
  components: {
    Subscription,
    Media,
    AdminPersonal,
    PaymentMethord,
    PurchasedPackage
  },
  created(){
    Store.dispatch("AdminProfile/getSubscriptionInformation")

  }
};
</script>



// WEBPACK FOOTER //
// src/components/profile/admin/AdminProfile.vue